// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3wjkM","visuallyhidden":"_3ed4p","hide-text":"_3enkl","center":"_2ejl4","noprint":"_1oBOm","menuTrigger":"_33NXf","menuLabelClosed":"_3vJNH","menuLabelOpen":"hEHeB","menuLabelOpen-menuOpen":"_3YJuM","menuLabelClosed-menuOpen":"_1z3dw","menuIconBox":"_1H0qa","menuIcon":"_3y3d0","menuIconInner":"_3qnNc","menuIconInner-menuOpen":"_1q7y9 _3qnNc","mainLinks-menuOpen":"_1EYbL","mainItem":"_15_fI","navList":"rrT_M","mainLink":"_1_CE9","masthead":"_3r-np","innerContainer":"GlkjF","logo":"HRIGx","widgets":"_2JUiM","iconLabel":"vtr8U","navSearchContainer":"_1Wa_4","navSearchContainer-menuOpen":"_3YaEl _1Wa_4"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/Masthead.scss
 ** module id = 963
 ** module chunks = 1
 **/